export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7401.91283ce5.jpg";